import { IAppState } from '../../../../common/state';

export function getOffersCount(state: IAppState) {
  const {
    results: { totalOffers },
    hideOffer: { hiddenOffers },
  } = state;

  return totalOffers - hiddenOffers.length;
}
